module.exports = __webpack_public_path__ + "static/media/Riverviewfarmslogo1994.be818e20.webp";